import { useEffect } from "react";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import WhatIsSection from "./components/WhatIsSection";
import BenefitsSection from "./components/BenefitsSection";
import FAQSection from "./components/FAQSection";
import ArticlePreviewSection from "./components/ArticlePreviewSection";
import CTASection from "./components/CTASection";
import FooterSection from "./components/FooterSection";

export default function Home() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <WhatIsSection />
        <BenefitsSection />
        <ArticlePreviewSection />
        <FAQSection />
        <CTASection />
      </main>
      <FooterSection />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Best Kakobuy Spreadsheet 2026 | Updated Daily Product Lists",
            "description": "Discover the latest Kakobuy Spreadsheet with trusted products, buying guides, shipping tips, and curated categories updated every day. Your go-to resource for smarter, faster shopping.",
            "url": "https://kakobuyspreadsheet.ink/",
            "isPartOf": {
              "@type": "WebSite",
              "name": "Kakobuy Spreadsheet",
              "url": "https://kakobuyspreadsheet.ink/",
            },
            "about": {
              "@type": "Thing",
              "name": "kakobuy spreadsheet",
            },
            "dateModified": "2026-06-25",
            "inLanguage": "en",
          }),
        }}
      />
    </>
  );
}